import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslationService } from '@core/services/common/translation.service';
import { ArkikDialogRef } from '../arkik-dialog/arkik-dialog-ref';
import { ARKIK_DIALOG_DATA } from '../arkik-dialog/arkik-dialog.service';

const DEFAULT_CONFIG: ConfirmationConfig = {
  title: 'views.globals.confirmAction',
  okButton: 'views.globals.confirm',
  cancelButton: 'views.globals.cancel',
  message: '',
  warning: '',
  hideCancelBtn: false,
};

@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalConfirmationComponent implements OnInit {
  constructor(
    @Inject(ARKIK_DIALOG_DATA) public data: ConfirmationConfig,
    private dialogRef: ArkikDialogRef<ModalConfirmationComponent>,
    private t: TranslationService,
  ) {}

  ngOnInit(): void {
    const DEFAULT = { ...DEFAULT_CONFIG };
    DEFAULT.title = this.t.pt(DEFAULT_CONFIG.title);
    DEFAULT.okButton = this.t.pt(DEFAULT_CONFIG.okButton);
    DEFAULT.cancelButton = this.t.pt(DEFAULT_CONFIG.cancelButton);
    this.data = { ...DEFAULT, ...this.data };
  }

  onOk(): void {
    this.dialogRef.close({ result: 'ok' });
  }

  onCancel(): void {
    this.dialogRef.close({ result: 'cancel' });
  }
}

export interface ConfirmationConfig {
  /** Title of the confirmation modal. Default: Confirm action */
  title?: string;
  /** Message of confirmation. Can use: views.globals.perform-action */
  message: string;

  warning?: string;
  /** Ok button text. Default: Confirm */
  okButton?: string;
  /** Cancel button text. Default: Cancel */
  cancelButton?: string;
  /** Hides cancel button. Ideal for only notifications messages */
  hideCancelBtn?: boolean;
}

export interface ConfirmationResult {
  result: 'ok' | 'cancel';
}
